import { gql } from '@apollo/client';

const GET_APPRAISAL_VIEW = gql`
  query GetAppraisalView($appraisalViewRequest: [AppraisalViewRequest]) {
    appraisalView(appraisalViewRequest: $appraisalViewRequest) {
      PracticeAreas {
        Name
        Acronym
        DefaultLevel
        IncludeHigherLevels
        IncludeHigherProgramYears
        IncludeExactMatchedDeviceClasses
        IncludeExactMatchedOhts
        Year
        AggregatePercentage {
          Name
          Results
          Cnt
        }
        Practices {
          Level
          NumberInLevel
          PracticeName
          Name
          Satisfied
          Partial
          Deficient
        }
      }
    }
    isPercentageVisible(reportName: "appraisal-view")
  }
`;

export default GET_APPRAISAL_VIEW;
